exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainMenuHeader{margin-top:15px !important}.appSidebar{width:220px}.sidebar{overflow:auto}.sidebar.open{left:0}.sidebarCloseBtn{display:none !important}.desktopOnlyLogo{margin:15px}@media only screen and (max-width: 900px){.mainMenuHeader{margin-top:0}.desktopOnlyLogo{display:none !important}.appSidebar{width:100vw}.sidebarCloseBtn{display:block !important;cursor:pointer;position:fixed;right:15px;top:10px}.mobileToggleOn{display:-ms-flexbox !important;display:flex !important}.mobileToggleOff{display:none}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/style.scss
// module id = 6210
// module chunks = 0